/**
 * Google Sign-In Button Component
 * 
 * Styled button with official Google branding for OAuth sign-in.
 */
import React, { useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

const GoogleSignInButton = ({ className = '', fullWidth = true }) => {
  const { signInWithGoogle } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const handleGoogleSignIn = async () => {
    setIsLoading(true);
    try {
      await signInWithGoogle();
    } catch (error) {
      console.error('Error signing in with Google:', error);
      setIsLoading(false);
    }
  };

  return (
    <Button
      onClick={handleGoogleSignIn}
      disabled={isLoading}
      fullWidth={fullWidth}
      variant="outlined"
      className={className}
      sx={{
        backgroundColor: '#ffffff',
        color: '#3c4043',
        border: '1px solid #dadce0',
        borderRadius: '8px',
        padding: '12px 24px',
        textTransform: 'none',
        fontSize: '16px',
        fontWeight: 500,
        fontFamily: '"Google Sans", Roboto, Arial, sans-serif',
        '&:hover': {
          backgroundColor: '#f8f9fa',
          border: '1px solid #dadce0',
          boxShadow: '0 1px 2px 0 rgba(60,64,67,0.3), 0 1px 3px 1px rgba(60,64,67,0.15)'
        },
        '&:active': {
          backgroundColor: '#f1f3f4'
        },
        '&:disabled': {
          backgroundColor: '#f1f3f4',
          color: '#9aa0a6'
        }
      }}
      startIcon={
        isLoading ? (
          <CircularProgress size={20} />
        ) : (
          <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fillRule="evenodd">
              <path
                d="M17.64 9.205c0-.639-.057-1.252-.164-1.841H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"
                fill="#4285F4"
              />
              <path
                d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z"
                fill="#34A853"
              />
              <path
                d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z"
                fill="#FBBC05"
              />
              <path
                d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z"
                fill="#EA4335"
              />
            </g>
          </svg>
        )
      }
    >
      {isLoading ? 'Signing in...' : 'Continue with Google'}
    </Button>
  );
};

export default GoogleSignInButton;
